import i18n from "@/app/i18n";
import { formatMoneyKzt } from "@/shared/utils";

export type MoneyString = string;

export function parseMoney(value: MoneyString): number {
  return parseFloat(value) || 0;
}

export function formatCurrency(value: MoneyString | number): string {
  return formatMoneyKzt(value);
}

export function formatCurrencyNoDecimals(
  value: MoneyString | number,
  withSignTenge = true,
  locale?: string,
): string {
  const currentLocale = (locale || i18n.language || "ru") as "ru" | "kk" | "en";
  const formatted = formatMoneyKzt(value, currentLocale, false);
  if (!withSignTenge) return formatted.replace(/\s*₸$/, "");
  return formatted;
}

export function formatCompact(value: number, locale?: string): string {
  const loc = locale || "ru";
  try {
    return new Intl.NumberFormat(loc, { notation: "compact", maximumFractionDigits: 1 }).format(value);
  } catch {
    return new Intl.NumberFormat("ru", { notation: "compact", maximumFractionDigits: 1 }).format(value);
  }
}

export function formatPercentage(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function formatAccountCode(account: string): string {
  return account.replace("→", "  →  ");
}

export function removeSectionNumber(name: string): string {
  return name.replace(/^[\d.]+\s*/, "");
}

